import styled from "styled-components";

const Input = styled.input`
width:80%;
display:block;
margin-left:auto;
margin-right:auto;
margin-top:2%;
margin-bottom:2%;
border-radius:5px;
height: 25px;
padding-left:2%;
`;

export default Input;